import { useIntl, defineMessages } from 'react-intl'
import Section from '../Section/Section'
import { ListingCardNew } from '../../ListingCardNew/ListingCardNew'
import { Grid, GridItem, Box, Flex, LoadingSpinner } from '@homebotapp/hb-react-component-catalog'
import { ClientEventName, ClientEventSource, ListingCompact } from '../../../../api/gqlaxy/gql/generated/graphql'
import { HOME_SEARCH_LISTING_DETAILS } from '../../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'
import { Waypoint } from 'react-waypoint'
import { useTrackingContext } from '../../../../providers/tracking'
import { useTrackingDebounceSetters } from '../../../../hooks/tracking'
import { LISTINGS_DETAILED, SIMILAR_HOMES } from '../../../../constants/tracking/trackingEventConstants'
import { useCreateClientEventOnView } from '../../../../hooks/useCreateClientEventOnView'
import { useGetSimilarListings } from '../../../../hooks/listings/useGetSimilarListings'

export const MSG = defineMessages({
  head: {
    id: 'ListingDetails.SimilarHomes.head',
    defaultMessage: 'Similar homes'
  }
})

export interface SimilarHomesProps {
  listingId: string
}

export const SimilarHomes = ({ listingId }: SimilarHomesProps) => {
  const intl = useIntl()
  const { trackingClient } = useTrackingContext()
  const [trackModuleViewed] = useTrackingDebounceSetters(
    () =>
      trackingClient?.moduleViewed({
        event_source: LISTINGS_DETAILED,
        module_name: SIMILAR_HOMES
      })
  )
  const createModuleViewedClientEvent = useCreateClientEventOnView({
    eventName: ClientEventName.ModuleViewed,
    eventSource: ClientEventSource.ListingDetailed,
    location: SIMILAR_HOMES,
    listingId,
    eventProperties: {
      module_name: SIMILAR_HOMES
    }
  })

  const trackAmplitudeAndCreateClientEvent = () => {
    trackModuleViewed()
    createModuleViewedClientEvent()
  }

  const { data: similarListingsData, isLoading } = useGetSimilarListings(
    {
      input: {
        listingId
      }
    },
    {}
  )

  // Not sure if we need a loading state here since this is below the fold
  if (isLoading) {
    return (
      <Flex align='center' justify='center' h='98px'>
        <LoadingSpinner variant='bot-head' size='lg' />
      </Flex>
    )
  }

  const similarListings: ListingCompact[] = similarListingsData?.similarListings?.listings || []

  if (!similarListings.length) {
    return null
  }

  return (
    <Section>
      <Section.Heading>{intl.formatMessage(MSG.head)}</Section.Heading>
      <Box>
        <Waypoint onEnter={trackAmplitudeAndCreateClientEvent} bottomOffset='25%' />
        <Grid templateColumns={['repeat(1, minmax(200px, 1fr))', null, 'repeat(2, minmax(200px, 1fr))', null, 'repeat(4, minmax(200px, 1fr))']} gap={4}>
          {similarListings.slice(0, 4).map(listing => (
            <GridItem key={listing.id}>
              <ListingCardNew
                listing={listing}
                tracking={{
                  // cSpell:ignore 4t4Aoae6B6nvKy8RpQLeWL
                  guid: '4t4Aoae6B6nvKy8RpQLeWL',
                  ui_context: HOME_SEARCH_LISTING_DETAILS,
                  descriptor: 'Similar Listing Clicked'
                }}
              />
            </GridItem>
          ))}
        </Grid>
      </Box>
    </Section>
  )
}
